import { VdPerformanceTracking, VdTracking } from '@vend/vend.js'

const VEND_SALE_MARK = 'vend-sale'
const MARK_START_PREFIX = 'start'
const MARK_STOP_PREFIX = 'stop'

interface Metadata {
  [key: string]: any
}

export class SaleTrackerService {
  private metadata: Metadata = {}

  constructor(
    private readonly vdPerformanceTracking: VdPerformanceTracking,
    private readonly vdTracking: VdTracking
  ) {
    'ngInject'
  }

  public initialiseTracking() {
    this.metadata = {}

    this.vdPerformanceTracking.clearAllByName([
      VEND_SALE_MARK,
      `${MARK_START_PREFIX} ${VEND_SALE_MARK}`,
      `${MARK_STOP_PREFIX} ${VEND_SALE_MARK}`,
    ])

    this.vdPerformanceTracking.start(VEND_SALE_MARK)
  }

  public isTrackingInitialised(): boolean {
    return Boolean(
      this.vdPerformanceTracking.getMark(
        `${MARK_START_PREFIX} ${VEND_SALE_MARK}`
      )
    )
  }

  public completeTracking(data: Metadata = {}) {
    if (!this.isTrackingInitialised()) {
      return
    }

    const measure = this.vdPerformanceTracking.stop(VEND_SALE_MARK)

    if (!measure) {
      return
    }

    this.vdTracking.trackUserEvent({
      eventName: 'Sale',
      metadata: {
        ...this.metadata,
        ...data,
        ...{ duration: measure.duration },
      },
      sendSynchronously: true,
    })
  }

  public addTrackingData(data: Metadata) {
    if (!this.isTrackingInitialised()) {
      return
    }

    this.metadata = {
      ...this.metadata,
      ...data,
    }
  }
}
